module.exports = __webpack_public_path__ + "img/lqct.ea6c894d.png";